import { render, staticRenderFns } from "./block-divider.vue?vue&type=template&id=674d68d7&scoped=true"
import script from "./block-divider.vue?vue&type=script&lang=js"
export * from "./block-divider.vue?vue&type=script&lang=js"
import style0 from "./block-divider.vue?vue&type=style&index=0&id=674d68d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674d68d7",
  null
  
)

export default component.exports